import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { GamePageComponent } from '../_contexts/_app/games/game-page/game-page.component';

const routes: Routes = [
    // { path: '', redirectTo: 'games/coins-collector', pathMatch: 'full' },
    { path: '', redirectTo: 'games/extreme-crossing', pathMatch: 'full' },
    { path: 'games/:gameId', component: GamePageComponent },
    // { path: '**', redirectTo: 'games/coins-collector' },
    { path: '**', redirectTo: 'games/extreme-crossing' },
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule],
})
export class AppRoutingModule { }
